import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import axiosConstants from "./axiosConstants";

const settings = {
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Credentials": true,
    "X-XSRF-TOKEN": axiosConstants.XSRF,
    Accept: "application/json"
  }
};

interface AxiosInstanceType {
  [x: string]: any;
  get: (url: string, request?: AxiosRequestConfig) => Promise<AxiosResponse>;
  post: (
    url: string,
    data?: any,
    request?: AxiosRequestConfig
  ) => Promise<AxiosResponse>;
  put: (
    url: string,
    data?: any,
    request?: AxiosRequestConfig
  ) => Promise<AxiosResponse>;
  patch: (
    url: string,
    data?: any,
    request?: AxiosRequestConfig
  ) => Promise<AxiosResponse>;
  delete: (url: string, request?: AxiosRequestConfig) => Promise<AxiosResponse>;
}

const getAxiosInstance = (
  _instance: AxiosInstance,
  getAdditionalHeaders?: () => Record<string, string>
) => {
  return {
    async get(url: string, config?: AxiosRequestConfig) {
      try {
        const response = await _instance.get(url, {
          ...(config || {}),
          headers: {
            ...(getAdditionalHeaders?.() || {}),
            ...(config?.headers || {})
          }
        });
        return await Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async post(url: string, data: any, config?: AxiosRequestConfig) {
      try {
        const response = await _instance.post(url, data, {
          ...(config || {}),
          headers: {
            ...(getAdditionalHeaders?.() || {}),
            ...(config?.headers || {})
          }
        });
        return await Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async put(url: string, data: any, config?: AxiosRequestConfig) {
      try {
        const response = await _instance.put(url, data, {
          ...(config || {}),
          headers: {
            ...(getAdditionalHeaders?.() || {}),
            ...(config?.headers || {})
          }
        });
        return await Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async patch(url: string, data: any, config?: AxiosRequestConfig) {
      try {
        const response = await _instance.patch(url, data, {
          ...(config || {}),
          headers: {
            ...(getAdditionalHeaders?.() || {}),
            ...(config?.headers || {})
          }
        });
        return await Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async delete(url: string, config?: AxiosRequestConfig) {
      try {
        const response = await _instance.delete(url, {
          ...config,
          headers: {
            ...(getAdditionalHeaders?.() || {}),
            ...(config?.headers || {})
          }
        });
        return await Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    }
  };
};

const baseURLVirtualCard =
  process.env.NODE_ENV === "production"
    ? "virtual-card-portlet"
    : "https://vcp-admin-service.k8.isw.la/vcp-admin";

const instanceVirtualCard = axios.create({
  ...settings,
  baseURL: baseURLVirtualCard
});

if (process.env.NODE_ENV !== "production") {
  instanceVirtualCard.defaults.headers.common.Authorization =
    "Bearer eyJhbGciOiJSUzI1NiJ9.eyJsYXN0TmFtZSI6ImlzdyIsImZpcnN0TG9naW4iOmZhbHNlLCJ1c2VyX25hbWUiOiJhZ2Jpc3dAc2hhcmtsYXNlcnMuY29tIiwibW9iaWxlTm8iOm51bGwsImNsaWVudF9pZCI6InNtYXJ0Y2FyZHByb2Nlc3MiLCJmaXJzdE5hbWUiOiJhZ2VuY3lfYmFua2luZyIsImVtYWlsVmVyaWZpZWQiOnRydWUsImF1ZCI6WyJjYXJkbGVzcy1zZXJ2aWNlIiwiaW5jb2duaXRvIiwiaXN3LWNvcmUiLCJpc3ctcG9zdC1vZmZpY2UiLCJwYXNzcG9ydCIsInNhZmV0b2tlbi1hZG1pbi1hcGkiLCJzY3AiLCJ2YXVsdCJdLCJzY29wZSI6WyJwcm9maWxlIl0sImV4cCI6MTcxMDk4Mjc5NiwibW9iaWxlTm9WZXJpZmllZCI6ZmFsc2UsImNsaWVudF9uYW1lIjoiU21hcnRjYXJkcHJvY2VzcyIsImp0aSI6ImJlYTRkODJjLWQ0MzctNDA5Ni1hNmVmLTBhNTU4YzkwMDFhZSIsImVtYWlsIjoiYWdiaXN3QHNoYXJrbGFzZXJzLmNvbSIsInBhc3Nwb3J0SWQiOiJFQjFDMTJBQi1FODQwLTRDNEMtODI4MS03QTc3NjA2QkFFMDIifQ.dzgqZy--pikpL8npqUDeYVv4YXCmte56Z88CjdwwmZ5dWPXrfrguaru8k8U_1_Wzbbsru0rRQZYYoo3UrQNxiCi-Jwd0N9P4xASwmXQFmEttrmPiAKjRH6DcDX8nOdQyzMYgmHQ_RsgVkJpih1NJJx0qlgMpXZCGWJzCx0V763AJT-MCv2zudDnTNYoVeu8I5-yaL5Dh59K7CEe6-ASLddxneBaDeR-8TyAW5wRUgZT5eYYT90v2Wp1CU4dYTzkxGMX-AaAUoGczZEa6sDNbh6mjpWVz-jmbcq9i9MYSa22p4rr07E8SNM9v6N9j7GCxzrJDJqFLZKSTXNFV9OCsrw";
}

export const axiosInstanceVirtualCard: AxiosInstanceType =
  getAxiosInstance(instanceVirtualCard);
